import React from 'react';
import {useFeaturePermission} from '../../contexts/FeatureBoundary';
import {GlobalPermissionEnum} from '../../schema-types/globalTypes';
import {BuilderFeeCalculator} from '../../features/builder/BuilderFeeCalculator/BuilderFeeCalculator';
import {FeesBreakdownSection} from './FeesBreakdownSection';

/**
 * Chooses which fees section to show on the handover summary:
 * - Dentist builder users see the BuilderFeeCalculator (with an optional BAU view).
 * - Everyone else sees the BAU Fees Breakdown.
 */
export const HandoverFeesSummary: React.FC = () => {
  const hasDentistBuilder = useFeaturePermission([
    GlobalPermissionEnum.can_access_dentist_recommendation_builder,
  ]);

  return hasDentistBuilder ? <BuilderFeeCalculator /> : <FeesBreakdownSection />;
};
